console.log("Hello from hike_list_show.ts on vite");
import "./application";
import '../apps/hike_list_manager/main.ts';
import '../apps/download_modal/main';

// Load comments asynchronously to avoid blocking page interactivity (dropdowns, etc.)
const commentsContainer = document.getElementById('comments');
if (commentsContainer) {
  // Use requestIdleCallback if available, otherwise fall back to setTimeout
  const loadComments = () => import('../apps/comments/main');
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadComments);
  } else {
    setTimeout(loadComments, 0);
  }
}
